// getMyNewsItem
import gql from "graphql-tag";

export const MY_NEWS_GET_ITEM_FILTER = gql`
  query getMyNewsItemFilter($newsId: String!) {
    getMyNewsItemFilter(newsId: $newsId) {
      company
      orgUnit
      workingPlace
      jobClassGroup
      payOffice
      contract
    }
  }
`;
